import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Integrator } from 'src/app/shared/models/integrator.model';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class IntegratorService {
  constructor(private http: HttpClient) {}

  public getEcommerceIntegrators(): Observable<Integrator[]> {
    return this.http.get<Integrator[]>(
      `${environment.apiUrls.integrators}`,
      { params: { technologyType: 'ONLINE' } }
    );
  }
}
